<homey-page-title title="Reset password"/>
@let currentState = state();
@switch (currentState.step) {
  @case ('link-expired') {
    <p-message severity="warn" class="block mb-4">
      This password reset link has expired. Request a new link to continue.
    </p-message>
    @if (currentState.resendError; as resendError) {
      <p-message severity="error" class="block mb-4">
        {{ resendError }}
      </p-message>
    }
    <homey-submit-button class="w-full" submitButtonLabel="Resend reset link" [submitFunction]="resendResetLink"/>
  }
  @case ('code-mismatch') {
    <p-message severity="error" class="block mb-4">
      The code you entered is incorrect or has expired. Please request a new code and try again.
    </p-message>
    @if (currentState.resendError; as resendError) {
      <p-message severity="error" class="block mb-4">
        {{ resendError }}
      </p-message>
    }
    <homey-submit-button class="w-full" submitButtonLabel="Resend code" [submitFunction]="resendResetLink"/>
  }
  @case ('awaiting-code') {
    @if (currentState.resent) {
      <p-message severity="success" class="block mb-4">
        <span>We sent a new reset code to <span class="font-medium break-words">{{ email || 'your email' }}</span>. Please check your inbox.</span>
      </p-message>
    } @else {
      <p-message severity="success" class="block mb-4">
        <span>We've sent a password reset email to <span class="font-medium break-words">{{ email }}</span>.</span>
      </p-message>
    }
    <p class="text-muted-color text-sm">Click the link in the email to reset your password, or <button class="underline cursor-pointer" (click)="startEnteringCode()">enter the code manually</button>.</p>
    <p class="text-sm text-muted-color mt-4">Don't forget to check your "Spam", "Notification", "Newsletter", "Social"... folders if you don't see the email in your inbox.</p>
  }
  @case ('entering-code') {
    @if (currentState.resent) {
      <p-message severity="success" class="block mb-4">
        <span>We sent a new reset code to <span class="font-medium break-words">{{ email || 'your email' }}</span>. Please check your inbox.</span>
      </p-message>
    } @else {
      <p-message severity="success" class="block mb-4">
        <span>We've sent a password reset email to <span class="font-medium break-words">{{ email }}</span>. Click the link in the email to reset your password.</span>
      </p-message>
    }
    <p class="text-sm text-muted-color mb-8">Don't forget to check your "Spam", "Notification", "Newsletter", "Social"... folders if you don't see the email in your inbox.</p>
    <div class="flex flex-col items-center gap-4">
      <p-inputotp [formControl]="form.controls.code" [length]="6" [integerOnly]="true"/>
      <p-button class="w-full flex-1" styleClass="w-full" label="Enter code" [disabled]="form.controls.code.invalid" (click)="confirmCode()"></p-button>
    </div>
  }
  @case ('entering-password') {
    <p class="mb-4">Enter a new password for your account.</p>
    <homey-custom-form [formGroup]="form" submitButtonLabel="Reset password" [submitFunction]="submit">
      <homey-form-inputs>
        <homey-text-input [inputFormControl]="form.controls.password"
                          inputId="password"
                          label="New password"
                          errorMessage="Your password needs to be at least 8 characters including a lower-case letter, an upper-case letter, a number and one special character (!@#$%^&*)"
                          [type]="{type: 'password', autocomplete: 'new-password'}"/>
      </homey-form-inputs>
    </homey-custom-form>
  }
}
